export default __webpack_public_path__ + "static/ex2-signature-64c090405e18c638a53d7a2c59dbb5ad.webp";